
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bookmarks/books",
      function () {
        return require("private-next-pages/bookmarks/books.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bookmarks/books"])
      });
    }
  